var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolboxGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 118.7V71H138.43V118.7C138.43 119.575 138.257 120.442 137.922 121.251C137.587 122.06 137.095 122.794 136.476 123.413C135.856 124.031 135.121 124.522 134.312 124.856C133.503 125.19 132.635 125.361 131.76 125.36H23.67C22.7946 125.361 21.9274 125.19 21.1183 124.856C20.3091 124.522 19.5737 124.031 18.9542 123.413C18.3347 122.794 17.8432 122.06 17.5079 121.251C17.1726 120.442 17 119.575 17 118.7Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.76 51.0001V75.3601H13.6699V51.0001C13.6699 49.2328 14.3713 47.5378 15.62 46.2872C16.8687 45.0366 18.5627 44.3327 20.3299 44.3301H135.09C136.859 44.3301 138.555 45.0328 139.806 46.2837C141.057 47.5345 141.76 49.2311 141.76 51.0001Z",
    fill: "#CDD9E2",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8799 76.55H144.55",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.18 69H40.63C40.017 69 39.52 69.497 39.52 70.11V80.62C39.52 81.233 40.017 81.73 40.63 81.73H43.18C43.7931 81.73 44.29 81.233 44.29 80.62V70.11C44.29 69.497 43.7931 69 43.18 69Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.79 69H112.24C111.627 69 111.13 69.497 111.13 70.11V80.62C111.13 81.233 111.627 81.73 112.24 81.73H114.79C115.403 81.73 115.9 81.233 115.9 80.62V70.11C115.9 69.497 115.403 69 114.79 69Z",
    fill: "#1F323D",
    stroke: "#1F323D",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.27 45.29V32.92C56.27 31.8857 56.6809 30.8937 57.4123 30.1623C58.1437 29.4309 59.1357 29.02 60.17 29.02H95.26C96.2936 29.0227 97.284 29.4344 98.0148 30.1652C98.7456 30.896 99.1574 31.8865 99.16 32.92V45.29",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8101 44.9999V36.1999C92.8101 35.9931 92.7279 35.7947 92.5817 35.6484C92.4354 35.5021 92.237 35.4199 92.0301 35.4199H63.4001C63.1933 35.4199 62.9949 35.5021 62.8486 35.6484C62.7023 35.7947 62.6201 35.9931 62.6201 36.1999V44.9999",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolboxGrey);
export default __webpack_public_path__ + "static/media/toolbox_grey.142ac65a30857100212d549a83d4833e.svg";
export { ForwardRef as ReactComponent };